const STORAGE_KEY = 'truss_password_recovery_pending';
export const PASSWORD_RECOVERY_PENDING_EVENT = 'truss:password-recovery-pending';
export const PASSWORD_RECOVERY_CLEARED_EVENT = 'truss:password-recovery-cleared';

export function setPasswordRecoveryPending(): void {
    sessionStorage.setItem(STORAGE_KEY, '1');
    window.dispatchEvent(new Event(PASSWORD_RECOVERY_PENDING_EVENT));
}

export function clearPasswordRecoveryPending(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(PASSWORD_RECOVERY_CLEARED_EVENT));
}

export function isPasswordRecoveryPending(): boolean {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
}
